import { useState, useEffect, useContext } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { userSignUpSchema } from "../../ZodSchemas/UserSchemas";
import {Link, useNavigate} from "react-router-dom"
import {authService} from "../../services"
import { AuthContext } from "../../context/AuthProvider";

const UserRegisterForm = () => {
  const [regLoading, setRegLoading] = useState(false);
  const [error, setError]=useState("")
    const { login, user, loading } = useContext(AuthContext);
      const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(userSignUpSchema),
  });
useEffect(()=>{
  if(user && !loading){
    navigate(user.isAdmin? "/admin" : "/user/my-dashboard"); 
  }
},[loading])

  const onSubmit = async (data) => {
    setRegLoading(true);
    console.log(data);

    try {
      const regUser=await authService.register(data)
      login(regUser.token)
   navigate("/user/my-dashboard"); 
    } catch (error) {
    setError(error)
    } finally {
      setRegLoading(false);
    }
  };
console.log(error);

  return (
    <div className="w-full bg-white/60">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="space-y-4 w-full max-w-[500px] mx-auto p-6 ">
        <h2 className="mb-4 text-gray-800 text-3xl text-center">Sign Up</h2>
      <h1 className="text-red-500 text-[12px] text-left mx-auto w-max"> {error && error.message} </h1>
        <div>
          <input
            {...register("username")}
            className={`${errors.username && 'inputError'}`}
            placeholder="Username"
          />
          {errors.username && (
            <p className="formErrorText">{errors.username.message}</p>
          )}
        </div>

        <div className="">
          <input
            {...register("stageName")}
            className={`${errors.stageName && 'inputError'}`}
            placeholder="Stage Name"
          />
          {errors.stageName && (
            <p className="formErrorText">{errors.stageName.message}</p>
          )}
        </div>

        <div className="flex gap-2">
          <div className="w-full -mt-4">
            <input
              {...register("fullName.fName")}
              placeholder="First Name"
             className={`${errors.fullName?.fName && 'inputError'}`}
            />
              <p className="formErrorText">{errors.fullName?.fName?.message}</p>
          </div>
          <div className="w-full -mt-4">
            <input
              {...register("fullName.lName")}
              placeholder="Last Name"
              className={`${errors.fullName?.lName && 'inputError'}`}
            />
  <p className="formErrorText">{errors.fullName?.lName?.message}</p>
          </div>
        </div>

        <div>
          <input {...register("email")}   className={`${errors.email && 'inputError'}`} placeholder="Email" />
          {errors.email && (
            <p className="formErrorText">{errors.email.message}</p>
          )}
        </div>

        <div>
          <input
            type="password"
            {...register("password")}
            className={`${errors.password && 'inputError'}`}
            placeholder="Password"
          />
          {errors.password && (
            <p className="formErrorText">{errors.password.message}</p>
          )}
        </div>

        <div>
          <input
            type="password"
            {...register("comfirmPassword")}
            className={`${errors.comfirmPassword && 'inputError'}`}
            placeholder="Comfirm Password"
          />
          {errors.comfirmPassword && (
            <p className="formErrorText">{errors.comfirmPassword.message}</p>
          )}
        </div>
<p>By signing up, you have read and agreed to our <Link className="text-blue-800 underline" to="/terms-conditions"> Terms and Conditions</Link></p>
        <button
          type="submit"
          className="formSubmitBtn"
          disabled={regLoading}>
          {regLoading ? "Registering..." : "Register"}
        </button>
        <p>Have an account?<Link className="text-blue-800 underline" to="/login"> Sign-in</Link></p>
      </form>
    </div>
  );
};

export default UserRegisterForm;
